import baseArticles from '../data/articles'
import { safeReadJson, safeWriteJson, safeRemove } from './storage'

const STORAGE_KEY = 'articles_db_v1'
const EVENT_NAME = 'articles-db-updated'

const normalizeArticle = (article) => {
  return {
    articleName: String(article.articleName || '').trim(),
    articleDate: String(article.articleDate || '').trim(),
    articleType: Array.isArray(article.articleType)
      ? article.articleType.map((type) => String(type).trim()).filter(Boolean)
      : [],
    articleContent: String(article.articleContent || ''),
  }
}

const normalizeArticles = (articles) => {
  if (!Array.isArray(articles)) return []
  return articles
    .map(normalizeArticle)
    .filter((article) => article.articleName && article.articleContent)
}

const emitUpdate = () => {
  window.dispatchEvent(new Event(EVENT_NAME))
}

export const getBaseArticles = () => normalizeArticles(baseArticles)

export const getArticles = () => {
  const stored = safeReadJson(STORAGE_KEY, null)
  if (Array.isArray(stored) && stored.length > 0) {
    return normalizeArticles(stored)
  }
  return getBaseArticles()
}

export const saveArticles = (articles) => {
  const normalized = normalizeArticles(articles)
  safeWriteJson(STORAGE_KEY, normalized)
  emitUpdate()
  return normalized
}

export const resetArticles = () => {
  safeRemove(STORAGE_KEY)
  emitUpdate()
}

export const onArticlesUpdated = (callback) => {
  const handler = () => callback(getArticles())
  window.addEventListener(EVENT_NAME, handler)
  window.addEventListener('storage', handler)

  return () => {
    window.removeEventListener(EVENT_NAME, handler)
    window.removeEventListener('storage', handler)
  }
}

export const articlesStorageKey = STORAGE_KEY
